import { ListItem, StyledComponentProps, Divider } from '@material-ui/core';
// import { Contact, Message, Check } from '../../../../ui-components/Icons';
import * as React from 'react';
import { reminder } from '../../../model/reminder';
import { ReminderInfo } from './ReminderInfo';
// import { contact } from '../../../../model/contact';
// import Tag from '../Tag/Tag';
// import Room from '../Room/Room';
// import { styles } from './styles';
// import { ContactInfo } from './ContactInfo';
// import ExpandDownButton from '../../../../ui-components/Button/ExpandDownButton';
// import CollapseUpButton from '../../../../ui-components/Button/CollapseUpButton';

interface IProps extends StyledComponentProps {
    doneReminder: (reminder: reminder, done: boolean) => void;
    onReminderClick: (_id: string) => void;
    reminder: reminder;
    isSelected: boolean;
    showContactInfo?: boolean;
    // navigateTo: (path: string) => void;
}
interface IState {
    // open: boolean;
    // reminder: reminder;
    // openRoom: boolean;
}


export class ReminderItem extends React.Component<IProps, IState> {
    // state = { open: false } //, reminder: this.props.reminder }

    setSelected = (_done: boolean) => {
        this.props.doneReminder(this.props.reminder, _done);
        // console.log("REMINDERRRRRRRRRRRRRRRRRRR SET SELECTED :" + _done); // JSON.stringify(this.state.reminder));
    }

    // private expandTags = (evt: React.MouseEvent<SVGSVGElement, MouseEvent>, open: boolean, openRoom: boolean) => {
    //     this.setState({
    //         open: open,
    //         // openRoom: open
    //     });
    //     evt.stopPropagation();
    // }

    render() {
        const { reminder, classes } = this.props;
        return (
            <>
                <ListItem button>
                    <ReminderInfo reminder={reminder} 
                        classes={classes} 
                        clickItem={this.props.onReminderClick} 
                        showContactInfo={this.props.showContactInfo ?? true}
                        setSelected={this.setSelected} />
                </ListItem>
                <Divider />
            </>
        );
    }
}